/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UpdateDocumentMiscSettingRequestDocumentMiscSettingFromJSON, UpdateDocumentMiscSettingRequestDocumentMiscSettingToJSON } from './UpdateDocumentMiscSettingRequestDocumentMiscSetting';
export function UpdateDocumentMiscSettingRequestFromJSON(json) {
    return UpdateDocumentMiscSettingRequestFromJSONTyped(json, false);
}
export function UpdateDocumentMiscSettingRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        documentMiscSetting: !exists(json, 'document_misc_setting')
            ? undefined
            : UpdateDocumentMiscSettingRequestDocumentMiscSettingFromJSON(json['document_misc_setting'])
    };
}
export function UpdateDocumentMiscSettingRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        document_misc_setting: UpdateDocumentMiscSettingRequestDocumentMiscSettingToJSON(value.documentMiscSetting)
    };
}
